import { useState, useEffect } from "react";

import RedAccordianArrowDown from "../../Assets/Images/AccordianArrowDown.svg";
import AccordianArrowUp from "../../Assets/Images/AccordianArrowUp.svg";
import WhyListIcon from "../../Assets/Images/about-list-shape-icon.svg";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const InternationalClientsData = () => {
  // const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [openPanels, setOpenPanels] = useState({
    panel1: false,
    panel2: true,
  });

  const togglePanel = (panel) => {
    setOpenPanels((prev) => ({ ...prev, [panel]: !prev[panel] }));
  };

  const translations = useTranslation(); // Get translations dynamically
    useAnimateOnScroll();

  return (
    <div
      id="Afibl"
      className=" accordion-main lg:pt-2 lg:pb-10 md:pb-[2rem] pt:2"
    > 
        <div className="flex flex-col lg:flex-row gap-8 lg:px-0 px-4">
          {/* Left Section */}

          {/* Right Section */}
          <div className="py-0 md:py-16 max-w-[506px] international-client-content-wrap">
            <div className="hidden md:block ">
              <h2 className="text-[26px] md:text-[40px] font-bold mb-2 FAQheading extra-title-heading">
                {translations.internationalHeading}
              </h2>
              <hr class="bordertitle-line mb-4"></hr>
            </div>

            <p className="text-[14px] md:text-[14px] leading-[19px] md:leading-[22px] animated fadeInUp mt-8 tracking-tight extra-para-vs">
              {translations.internationalDescription}
            </p>

            <div class="py-8  animated fadeInUp">
              <h2 className="text-[14px] font-bold extra-para-vs">{translations.internationalPurposeTitle}</h2>
              <ul>
                <li className="text-[14px] leading-[22px] tracking-tight border-b border-[#C6C4C4] pb-4 extra-para-vs">{translations.internationalPurposeDesc1}</li>
                <li className="text-[14px] leading-[22px] tracking-tight border-b border-[#C6C4C4] pb-4 pt-4 extra-para-vs">{translations.internationalPurposeDesc2}</li>
                <li className="text-[14px] leading-[22px] tracking-tight pt-4 extra-para-vs">{translations.internationalPurposeDesc3}</li>
              </ul> 
            </div>

            {/* <div className="mt-2">
              <div id="accordion-open" data-accordion="open">
                <h2
                  id="accordion-open-heading-2 "
                  className="animate__animated animate__fadeInDown"
                >
                  <button
                    type="button"
                    class="flex items-center justify-between w-full py-4 text-[1rem] font-semibold border-b  border-[#AFA07B] mt-[0rem]"
                    data-accordion-target="#accordion-open-body-2"
                    aria-expanded="false"
                    aria-controls="accordion-open-body-2"
                  >
                    Purpose{" "}
                    <img
                      src={
                        !openPanels.panel2
                          ? RedAccordianArrowDown
                          : AccordianArrowUp
                      }
                      alt="Arrow Icon"
                      onClick={() => togglePanel("panel2")}
                    />
                  </button>
                </h2>
                <div
                  id="accordion-open-body-2"
                  className={`${
                    openPanels.panel2
                      ? "animate_animated  animate_fadeInDown"
                      : "hidden"
                  }`}
                >
                  <div class="py-4  ">
                    <p className="text-[14px] mb-4 leading-[22px]">
                      American Fidelity International Ltd.'s goals are based on
                      two basic principles:
                    </p>
                    <ol className="text-[14px] leading-[22px]">
                      <li>
                        1. To provide our international clients with quality
                        products to help meet their financial needs.{" "}
                      </li>
                      <li>
                        2. To help provide our international clients with
                        financial protection solutions.
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div> 
    </div>
  );
};

export default InternationalClientsData;
